import React from 'react'

const CurtainsSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 14 14'
    >
      <g id='Curtains' transform='translate(-7 -7)'>
        <path
          id='Path_3158'
          data-name='Path 3158'
          d='M8.011,21H9.75a.661.661,0,0,0,.47-.2.638.638,0,0,0,.182-.468,5.317,5.317,0,0,0-1-3.4,1.008,1.008,0,0,0,.154-1.568c1.07-.56,3.108-2.153,3.2-6.342h2.486c.09,4.2,2.128,5.79,3.2,6.342a1.008,1.008,0,0,0,.154,1.568,5.3,5.3,0,0,0-1,3.4.638.638,0,0,0,.182.468.661.661,0,0,0,.47.2h1.739A1.011,1.011,0,0,0,21,19.989V8.011A1.011,1.011,0,0,0,19.989,7H8.011A1.011,1.011,0,0,0,7,8.011V19.989A1.011,1.011,0,0,0,8.011,21Zm.84-4.46H7.56v-.9H8.851a.451.451,0,1,1,0,.9ZM7.8,15.078H7.56V9.024H10.2C10.128,13.787,8.1,14.935,7.8,15.078ZM7.56,19.989V17.1h.182c.16.2.655,1,.692,3.34H8.011a.451.451,0,0,1-.451-.451Zm2.19.451H8.994A7.817,7.817,0,0,0,8.4,17.1h.372c.2.146.994.865,1.07,3.251a.09.09,0,0,1-.092.09Zm-.938-5.362H8.767c.812-.748,1.94-2.436,2-6.054H12.2C12.088,13.927,9.17,14.969,8.812,15.078Zm7-6.054h1.434c.056,3.618,1.184,5.32,2,6.054H19.2c-.342-.106-3.284-1.182-3.394-6.054Zm3.36,7.515a.451.451,0,1,1,0-.9H20.44v.9Zm1.268-1.462H20.2c-.3-.146-2.327-1.3-2.4-6.054H20.44ZM18.158,20.35c.076-2.394.876-3.111,1.07-3.251H19.6a7.817,7.817,0,0,0-.594,3.34H18.25a.09.09,0,0,1-.092-.09Zm2.282-.361a.451.451,0,0,1-.451.451h-.423c.039-2.358.538-3.153.692-3.34h.182ZM7.56,8.011a.451.451,0,0,1,.451-.451H19.989a.451.451,0,0,1,.451.451v.454H7.56Z'
        />
      </g>
    </svg>
  )
}

export default CurtainsSvg
